import { Page } from 'layouts/Page';
import { FC } from 'react';
import { ErrorsTable } from 'components/ErrorsCorrections/ErrorsTable';

export const ErrorsTablePage: FC = () => {
	return (
		<Page title="Errors Table – EAS Control Center">
			<ErrorsTable />
		</Page>
	);
};
